import { render } from "./InfoHome.vue?vue&type=template&id=fae62226&scoped=true"
import script from "./InfoHome.vue?vue&type=script&lang=js"
export * from "./InfoHome.vue?vue&type=script&lang=js"

import "./InfoHome.vue?vue&type=style&index=0&id=fae62226&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fae62226"]])

export default __exports__